import { 
  MdHome, MdPhone, MdInfo, MdStorefront, MdBuild, 
  MdPhotoLibrary, MdArticle, MdLocationOn, 
  MdPerson, MdSettings, MdShoppingCart, MdFavorite, 
  MdSearch, MdNotifications, MdChat, MdEvent,
  MdDashboard, MdLocalOffer
} from 'react-icons/md';

// Manteremos a propriedade URL nos primeiros 8 ícones para retrocompatibilidade
// de renderização caso um app antigo não tenha a propriedade ID preenchida perfeitamente,
// mas a interface sempre preferirá renderizar o 'icon' (Componente React).

export const predefinedIcons = [
  { id: 1, name: 'Home', icon: MdHome, url: 'https://cdn-icons-png.flaticon.com/512/25/25694.png', price: 0 },
  { id: 2, name: 'Contato', icon: MdPhone, url: 'https://cdn-icons-png.flaticon.com/512/159/159832.png', price: 0 },
  { id: 3, name: 'Sobre', icon: MdInfo, url: 'https://cdn-icons-png.flaticon.com/512/157/157933.png', price: 0 },
  { id: 4, name: 'Produtos', icon: MdStorefront, url: 'https://cdn-icons-png.flaticon.com/512/3144/3144456.png', price: 0 },
  { id: 5, name: 'Serviços', icon: MdBuild, url: 'https://cdn-icons-png.flaticon.com/512/1006/1006555.png', price: 0 },
  { id: 6, name: 'Galeria', icon: MdPhotoLibrary, url: 'https://cdn-icons-png.flaticon.com/512/709/709790.png', price: 0 },
  { id: 7, name: 'Blog', icon: MdArticle, url: 'https://cdn-icons-png.flaticon.com/512/2098/2098402.png', price: 0 },
  { id: 8, name: 'Localização', icon: MdLocationOn, url: 'https://cdn-icons-png.flaticon.com/512/684/684908.png', price: 0 },
  { id: 9, name: 'Perfil', icon: MdPerson, url: '', price: 0 },
  { id: 10, name: 'Ajustes', icon: MdSettings, url: '', price: 0 },
  { id: 11, name: 'Carrinho', icon: MdShoppingCart, url: '', price: 0 },
  { id: 12, name: 'Favoritos', icon: MdFavorite, url: '', price: 0 },
  { id: 13, name: 'Busca', icon: MdSearch, url: '', price: 0 },
  { id: 14, name: 'Avisos', icon: MdNotifications, url: '', price: 0 },
  { id: 15, name: 'Chat', icon: MdChat, url: '', price: 0 },
  { id: 16, name: 'Eventos', icon: MdEvent, url: '', price: 0 },
  { id: 17, name: 'Painel', icon: MdDashboard, url: '', price: 0 },
  { id: 18, name: 'Ofertas', icon: MdLocalOffer, url: '', price: 0 },
];
